import api from './api';

export const getAll = async () => {
  try {
    const response = await api.get(`/questionTypes/getAll`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener las encuestas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};
